import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import MainLayout from '../../layouts/Private';
import { Foundation } from '../route';
import { authenticationService } from '../../services/context/AuthService';

const PrivateRoute = ({ component: Component, auth, firstTimeIn, ...rest }) => {
  console.log('auth   ------------>' + auth);

  const currentUser = JSON.parse(localStorage.getItem("currentUser"));

  if (auth === null) {
    return (
      // Show the component only when the user is logged in
      // Otherwise, redirect the user to /signin page
      <Route {...rest} render={(props) => <div></div>} />
    );
  }
  return (
    // Show the component only when the user is logged in
    // Otherwise, redirect the user to /signin page
    <Route
      {...rest}
      render={(props) =>
        auth ? (
          firstTimeIn && !currentUser.email.endsWith('@hp.com') ? (<Redirect to="/userinfo" />) :
          (<MainLayout>
            <Component {...props} />
          </MainLayout>)
        ) : (
          <Redirect to="/login" />
        )
      }
    />
  );
};

export default PrivateRoute;
